import { useContext, useMemo } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import {
  FaMoneyBillWave, FaWallet, FaGlobeAmericas, FaEnvelopeOpenText,
} from "react-icons/fa";

// Los módulos llegan como árbol (módulo -> submodulos), hay que buscar recursivamente.
function tieneModulo(modulos, idModulo) {
  return modulos.some(
    (m) => m.id_modulo === idModulo || (m.submodulos?.length && tieneModulo(m.submodulos, idModulo))
  );
}

const SECCIONES = [
  { idModulo: 14, ruta: "registro-entrada", nombre: "Registro de Entradas", descripcion: "Registro de diezmos, ofrendas y demás entradas", icono: FaMoneyBillWave },
  { idModulo: 15, ruta: "salida-general", nombre: "Salidas Tes. General", descripcion: "Salidas de dinero de tesorería general", icono: FaWallet },
  { idModulo: 18, ruta: "salida-misiones", nombre: "Salidas Tes. Misiones", descripcion: "Salidas de dinero de tesorería de misiones", icono: FaGlobeAmericas },
  { idModulo: 19, ruta: "carta-agradecimiento", nombre: "Carta de Agradecimiento", descripcion: "Genera cartas de agradecimiento por contribuciones", icono: FaEnvelopeOpenText },
];

export default function FinanzasHub() {
  const { modulos } = useContext(AuthContext);

  const secciones = useMemo(
    () => SECCIONES.filter((s) => tieneModulo(modulos, s.idModulo)),
    [modulos]
  );

  return (
    <div className="p-6 bg-slate-50">

      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-800">Finanzas</h1>
        <p className="text-sm text-slate-500">Selecciona una sección para administrar.</p>
      </div>

      {secciones.length === 0 ? (
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-10 text-center text-sm text-slate-400">
          No tienes acceso a ninguna sección de finanzas por el momento.
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {secciones.map((s) => {
            const Icono = s.icono;
            return (
              <Link
                key={s.idModulo}
                to={`/dashboard/finanzas/${s.ruta}`}
                className="bg-white rounded-xl shadow-sm border border-slate-200 p-5 hover:border-indigo-300 hover:shadow-md transition group"
              >
                <div className="w-10 h-10 rounded-lg bg-indigo-50 text-indigo-600 flex items-center justify-center mb-3 group-hover:bg-indigo-600 group-hover:text-white transition">
                  <Icono />
                </div>
                <p className="font-semibold text-sm text-slate-800">{s.nombre}</p>
                <p className="text-xs text-slate-400 mt-0.5">{s.descripcion}</p>
              </Link>
            );
          })}
        </div>
      )}

    </div>
  );
}
